$(document).ready(function() {
	$(document).on('click', '.product-add-to-comparison, .product-details__comparison-btn', function() {
		var obj = $(this);
		var categoryId = obj.data('categoryId');
		var productId = obj.data('productId');

		console.log({
			productId,
			categoryId,
		}, 'productData');

		$('.cm-comparison-widget').addClass('loading');
		$.ajax({
			url: window.location.href,
			type: 'POST',
			data: {
				cm_action: 'addProductToComparison',
				product_id: productId,
				category_id: categoryId,
			},
			dataType: 'JSON',
			success: function(response) {
				console.log(response, 'response');
				$('.cm-comparison-widget').html($(response.widget).html());
				$('.cm-comparison-widget').removeClass('loading');
				setTimeout(function() {
					if(!$('.cm-comparison-widget').hasClass('active')) {
						$('.cm-comparison-widget__header').trigger('click');
					}
				});
			}
		});
	});
});